import { Outlet, createFileRoute } from '@tanstack/react-router';

import { type PraetorListResponse, getListPraetorsQueryKey } from '@praetoid/client';

import PraetorTabBar from '~/app/praetors/dashboard/PraetorTabBar';
import CrumbContainer from '~/shared/CrumbContainer';

export const Route = createFileRoute('/_app/home/praetors/$praetorId')({
	beforeLoad: ({ context: { queryClient }, params: { praetorId } }) => {
		const praetors = queryClient.getQueryData<PraetorListResponse>(getListPraetorsQueryKey());
		const praetor = praetors?.find((p) => p.id === praetorId);

		return {
			getTitle: praetor?.name ?? 'Praetor'
		};
	},
	component: function PraetorLayout() {
		const { praetorId } = Route.useParams();

		return <CrumbContainer nav={<PraetorTabBar praetorId={praetorId} />} container={<Outlet />} />;
	}
});
